<div class="sk-cms-title {{terminal}}">
    <div class="title-line"></div>
    <div class="title-text">{{title}}</div>
    <div class="title-line left"></div>
</div>